
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const usePoultryTransaction = (onSuccess: () => void) => {
  const [selectedPoultry, setSelectedPoultry] = useState<any[]>([]);
  const [isCredit, setIsCredit] = useState(false);
  const [partialPayment, setPartialPayment] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerContact, setCustomerContact] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [customerSignature, setCustomerSignature] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");

  const calculateTotal = () => {
    return selectedPoultry.reduce((total, item) => {
      return total + (item.selectedQuantity * item.data.price);
    }, 0);
  };

  const handleAddTransaction = async () => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        toast.error("Vous devez être connecté pour effectuer une transaction");
        return;
      }

      const totalAmount = calculateTotal();
      const paidAmount = isCredit ? parseFloat(partialPayment || "0") : totalAmount;
      const remainingAmount = totalAmount - paidAmount;

      for (const poultry of selectedPoultry) {
        const transactionData = {
          transaction_type: 'sale',
          stock_item_id: poultry.id,
          quantity: poultry.selectedQuantity,
          unit_price: poultry.data.price,
          total_amount: poultry.selectedQuantity * poultry.data.price,
          transaction_date: new Date().toISOString(),
          created_by: user.id,
          payment_method: paymentMethod,
          is_fully_paid: !isCredit || remainingAmount === 0,
          paid_amount: paidAmount,
          remaining_amount: remainingAmount,
          payment_due_date: isCredit ? paymentDate : null,
          digital_signature: customerSignature,
          notes: isCredit 
            ? `Vente à crédit - Client: ${customerName} (${customerContact}) - Adresse: ${customerAddress}`
            : `Vente - ${paymentMethod}`
        };

        console.log("Données de la transaction:", transactionData);

        const { error: transactionError } = await supabase
          .from('poultry_transactions')
          .insert([transactionData]);

        if (transactionError) {
          console.error("Erreur transaction:", transactionError);
          throw transactionError;
        }

        const { error: stockError } = await supabase
          .from('stock_items')
          .update({ 
            quantity: poultry.quantity - poultry.selectedQuantity 
          })
          .eq('id', poultry.id);

        if (stockError) {
          console.error("Erreur stock:", stockError);
          throw stockError;
        }
      }

      toast.success("Transaction effectuée avec succès");
      onSuccess();
    } catch (error: any) {
      console.error("Erreur lors de l'ajout de la transaction:", error);
      toast.error(error.message || "Erreur lors de l'ajout de la transaction");
    }
  };

  return {
    selectedPoultry,
    setSelectedPoultry,
    isCredit,
    setIsCredit,
    partialPayment,
    setPartialPayment,
    customerName,
    setCustomerName,
    customerContact,
    setCustomerContact,
    paymentDate,
    setPaymentDate,
    customerSignature,
    setCustomerSignature,
    customerAddress,
    setCustomerAddress,
    paymentMethod,
    setPaymentMethod,
    calculateTotal,
    handleAddTransaction,
  };
};
